<template>
    <div>   
        <div class="form-group mb-2">
            <div ref="cardNumber" class="p-t-10 p-b-10 form-control input" 
            	:class="{'border-danger': hasErrors('cardNumber')}"></div>
            <div
                class="invalid-feedback animated d-block animated fadeIn"
                v-if="hasErrors('cardNumber')"
                v-text="getError('cardNumber')"></div>
        </div>
        <div class="row">
            <div class="col-6 p-l-0">
                <div class="form-group mb-2">
                    <div ref="cardExpiry" class="p-t-10 p-b-10 form-control input" 
                    	:class="{'border-danger': hasErrors('cardExpiry')}"></div>
                    <div
                        class="invalid-feedback d-block animated fadeIn"
                        v-if="hasErrors('cardExpiry')"
                        v-text="getError('cardExpiry')"
                    ></div>
                </div>
            </div>
            <div class="col-6 p-l-0 p-r-0">
                <div class="form-group mb-0">
                    <div ref="cardCvc" class="p-t-10 p-b-10 form-control input" 
                    	:class="{'border-danger': hasErrors('cardCvc')}"></div>
                    <div
                        v-if="hasErrors('cardCvc')"
                        class="invalid-feedback animated d-block"
                        v-text="getError('cardCvc')"
                    ></div>
                </div>
            </div>
        </div>        
    </div>	
</template>

<script>
	export default {
		props: [
            'cardNumberPlaceholder', 
            'cardExpiryPlaceholder', 
            'cardOwner'
        ],
        data() {
            return {
                stripe: Stripe(window.stripeKey),
                stripeErrors: [
                    { key: 'cardNumber', message: null, invalid: true},
                    { key: 'cardExpiry', message: null, invalid: true},
                    { key: 'cardCvc', message: null, invalid: true},
                ],
                cardElements: [],
                iPayment: null
            }
        },
        computed: {
            uniqueId() {
                let randomID = Math.floor(Math.random() * 10)
                return `card_${randomID}`
            }
        },
        mounted() {
            this.cardElements = this.createCardElements()

            this.cardElements.forEach(el => {
                el.addEventListener('change', (event) => {
                    if (event.error) {
                        let idx = _.findIndex(this.stripeErrors, el => el.key == event.elementType)
                        if (idx >= 0) {
                            this.$set(this.stripeErrors[idx], 'message', event.error.message)
                        } else {
                            this.stripeErrors.push({
                                key: event.elementType,
                                message: event.error.message
                            })
                        }
                    } else {
                        let idx = _.findIndex(this.stripeErrors, el => el.key == event.elementType)
                        if (idx >= 0) {
                            this.$set(this.stripeErrors[idx], 'message', null)
                            this.$set(this.stripeErrors[idx], 'invalid', false)
                        }
                    }
                });
            })
        },  
        methods: {
            createCardElements() {
                if (!this.stripe) {
                    return
                }

                let elements = this.stripe.elements({
                    fonts: [
                        {
                            cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i',
                        },
                    ],
                });

                let inputs = document.querySelectorAll('.input');
                inputs.forEach(function(input) {
                    input.addEventListener('focus', function() {
                        input.classList.add('focused');
                    });
                    input.addEventListener('blur', function() {
                        input.classList.remove('focused');
                    });
                    input.addEventListener('keyup', function() {
                        if (!_.isEmpty(input.value) && input.value.length === 0) {
                            input.classList.add('empty');
                        } else {
                            input.classList.remove('empty');
                        }
                    });
                });

                let style = {
                    base: {
                        color: '#4A4A4AE6',
                        fontFamily: '"Montserrat", sans-serif!important',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        },
                        ':focus': {
                            borderColor: '#17BEBB !important'
                        },
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };

                let cardNumber = elements.create('cardNumber', {
                    placeholder: this.cardNumberPlaceholder,
                });
                cardNumber.mount(this.$refs.cardNumber, {style: style});

                let cardExpiry = elements.create('cardExpiry', {
                    placeholder: this.cardExpiryPlaceholder,
                });
                cardExpiry.mount(this.$refs.cardExpiry, {style: style});

                let cardCvc = elements.create('cardCvc');
                cardCvc.mount(this.$refs.cardCvc, {style: style});

                return [cardNumber, cardExpiry, cardCvc]
            },
            async onSubmit() {
                this.resetErrors()

                return new Promise(async (resolve, reject) => {
                    const { paymentMethod, error} = await this.stripe.createPaymentMethod({
                        type: 'card',
                        billing_details: {
                            name: this.cardOwner
                        },
                        card: this.cardElements[0]
                    })

                    if (error) {
                        let idx = _.findIndex(this.stripeErrors, el => el.key == 'cardNumber')
                        if (idx >= 0) {
                            this.$set(this.stripeErrors[idx], 'message', error.message)
                            this.$set(this.stripeErrors[idx], 'invalid', true)
                        } else {
                            this.stripeErrors.push({
                                key: 'cardNumber',
                                message: error.message,
                                invalid: true
                            })
                        }
                        reject(error.message)
                    } else {
                        let idx = _.findIndex(this.stripeErrors, el => el.key == 'cardNumber')
                        if (idx >= 0) {
                            this.$set(this.stripeErrors[idx], 'message', null)
                            this.$set(this.stripeErrors[idx], 'invalid', false)
                        }
                        resolve({
                            token: paymentMethod,
                            cardElements: this.cardElements,
                            stripe: this.stripe,
                        })
                    }

                })
            },
            getError(key) {
                let idx = _.findIndex(this.stripeErrors, e => e.key == key)
                if (idx >= 0) {
                    return this.stripeErrors[idx].message
                }
            },
            hasErrors(key) {
                let idx = _.findIndex(this.stripeErrors, e => e.key == key)
                if (idx >= 0) {
                    return !_.isEmpty(this.stripeErrors[idx].message)
                }
            },
            resetErrors() {
                this.stripeErrors.forEach(e => {
                    e.message = null
                })
            },        	
        }      		
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationStripeForm.vue